import React from 'react';
import { motion } from 'framer-motion';
import { FileTextIcon, ZapIcon } from 'lucide-react';
import { ActionButton } from './ActionButton';
const mockupUrl = 'https://cdn.magicpatterns.com/uploads/j8ti3yDPn3sWion9JwdAby/Mockup_-_Protocolo_Barrido_Intestinal_(1x1).webp';
export function Hero() {
  return <section className="relative overflow-hidden bg-brand-dark px-4 pb-16 pt-12 sm:pb-24 sm:pt-16" data-id="element-61">
      <div className="pointer-events-none absolute inset-x-0 top-0 h-px bg-brand-green/40" data-id="element-62" />
      <div className="relative mx-auto max-w-5xl text-center" data-id="element-63">
        <motion.p initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} className="font-display text-lg font-bold tracking-[0.18em] sm:text-2xl mt-[-42px] bg-[4ADE80] text-[#4ADE80]" data-id="element-64">
          🌿BIOMA LÍVIDO™
        </motion.p>
        <motion.h1 initial={{
        opacity: 0,
        y: 18
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.1
      }} className="mx-auto max-w-5xl font-display font-bold text-white sm:text-5xl lg:text-6xl mt-[20px] mb-[-45px] text-[21px]" data-id="element-65">
          Eliminá el lodo intestinal y recuperá tu digestión en 30 días{' '}
          <span className="text-brand-light" data-id="element-66">
            sin dietas extremas ni medicamentos.
          </span>
        </motion.h1>

        <motion.div initial={{
        opacity: 0,
        y: 26
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.2,
        duration: 0.45
      }} className="mx-auto my-2 max-w-xs sm:my-4 sm:max-w-lg" data-id="element-67">
          <img src={mockupUrl} alt="Mockup del Protocolo Barrido Intestinal" width="1024" height="1024" fetchPriority="high" loading="eager" decoding="async" className="w-full drop-shadow-2xl mb-[-30px]" data-id="element-68" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.35
      }} className="mx-auto max-w-2xl" data-id="element-69">
          <p className="text-base font-bold tracking-[0.14em] text-brand-gold sm:text-xl font-[Inter,_sans-serif]" data-id="element-70">
            PROTOCOLO BARRIDO INTESTINAL™
          </p>
          <p className="mt-3 text-sm leading-relaxed text-slate-200 sm:text-base" data-id="element-71">
            El primer sistema de barrido intestinal para hombres y mujeres de
            más de 35 años que ya probaron de todo y todavía no encontraron la
            solución real.
          </p>
          <div className="mt-5 flex flex-wrap justify-center gap-2 text-xs font-medium text-slate-300 sm:text-sm" data-id="element-72">
            <span className="inline-flex items-center gap-2 rounded-full border border-white/15 bg-brand-ink px-3 py-2" data-id="element-73">
              <FileTextIcon className="h-4 w-4 text-brand-light" data-id="element-74" />
              100% PDF
            </span>
            <span className="inline-flex items-center gap-2 rounded-full border border-white/15 bg-brand-ink px-3 py-2" data-id="element-75">
              <ZapIcon className="h-4 w-4 text-brand-gold" data-id="element-76" />
              Acceso en 5 min
            </span>
          </div>
        </motion.div>
        <motion.div initial={{
        opacity: 0,
        scale: 0.97
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        delay: 0.45
      }} className="mx-auto mt-7 max-w-lg" data-id="element-77">
          <ActionButton showTrust data-id="element-78">QUIERO MI SISTEMA AHORA</ActionButton>
        </motion.div>
      </div>
    </section>;
}